import { render, staticRenderFns } from "./PrimaryInput.vue?vue&type=template&id=6ff2cb49"
import script from "./PrimaryInput.vue?vue&type=script&lang=js"
export * from "./PrimaryInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports